import React from 'react';
import {
  DropdownMenuSub,
  DropdownMenuSubTrigger,
  DropdownMenuSubContent,
  DropdownMenuItem,
} from '@/modern/components/ui/dropdown-menu';
import { eventStyles, STRIPED_TASK_STYLE } from '@/other/constants/TaskTypes';
import { Task } from '@/bryntum-lib/models/Task';
import { TaskStylePreview } from './TaskStylePreview';

interface TaskStylePickerProps {
  record: Task;
  onStyleChange?: (style: string) => void;
  disabled?: boolean;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  onContentMouseEnter?: () => void;
  onContentMouseLeave?: () => void;
}

const allStyles = [...eventStyles, STRIPED_TASK_STYLE];

export const TaskStylePicker: React.FC<TaskStylePickerProps> = ({
  record,
  onStyleChange,
  disabled,
  open,
  onOpenChange,
  onMouseEnter,
  onMouseLeave,
  onContentMouseEnter,
  onContentMouseLeave
}) => {
  const currentStyle = record?.taskStyle || eventStyles[0];
  const taskColor = record?.color || '#FF8A65'; // Fallback color

  const handleStyleSelect = (style: string, event: Event) => {
    event.preventDefault(); // Prevent menu from closing
    if (record) {
      record.taskStyle = style;
    }
    onStyleChange?.(style);
  };

  return (
    <DropdownMenuSub open={open} onOpenChange={onOpenChange}>
      <DropdownMenuSubTrigger
        disabled={disabled}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <i className="fa-light fa-palette w-4 h-4" />
        <span>Task Style</span>
      </DropdownMenuSubTrigger>
      <DropdownMenuSubContent
        className="w-56"
        onMouseEnter={onContentMouseEnter}
        onMouseLeave={onContentMouseLeave}
      >
        {allStyles.map((style) => (
          <DropdownMenuItem
            key={style}
            onSelect={(event) => handleStyleSelect(style, event)}
            className="p-2"
          >
            <TaskStylePreview style={style} isSelected={currentStyle === style} color={taskColor} />
          </DropdownMenuItem>
        ))}
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  );
};